import { routes } from "../../../AppRoutes";
import { getItemfromStorage, setItemToStorage } from "./common-utils";
import { getRoleNameList } from "./shared-data.service";
import { hasPermission, hasCategoryAccess } from "./permission.service";

export const getLeftNavs = () => {
  const appRoute: any = routes?.find((r: any) => r.path === "/app");
  if (!appRoute || !appRoute.routes) return [];

  return appRoute.routes.filter(route => {
    if (route.category) {
      return hasCategoryAccess(route.category);
    }
    return true; // Allow routes without category by default (like change password)
  });
};
export const getHomePage = () => {
  return getLeftNavs()?.[0].path;
};
export const checkPermission = (category: string, subCategory?: string) => {
  if (!subCategory) {
    // If only one arg is passed, we might need a mapping or it might be a category check
    return hasCategoryAccess(category);
  }
  return hasPermission(category, subCategory);
};
export const setEditQuestion = (val: boolean) => {
  setItemToStorage("edit_question", val);
};

export const getEditQuestion = () => {
  return getItemfromStorage("edit_question");
};

export const setExamInfo = (val: object[]) => {
  setItemToStorage("exam_info", val);
};

export const getExamInfo = () => {
  return getItemfromStorage("exam_info");
};

export const setSelectedExamInfo = (val: object) => {
  setItemToStorage("selectedExamInfo", val);
};

export const getSelectedExamInfo = () => {
  return getItemfromStorage("selectedExamInfo");
};
